module.exports = __webpack_public_path__ + "static/media/live22_05_2018.6ceb4cd6.jpg";